export function installPromiseWithResolversPolyfill() {
  if (typeof Promise.withResolvers === "function") {
    return;
  }
  Promise.withResolvers = <T>(): PromiseWithResolvers<T> => {
    let resolve!: PromiseWithResolvers<T>["resolve"],
      reject!: PromiseWithResolvers<T>["reject"];
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

installPromiseWithResolversPolyfill();
